// extracted by mini-css-extract-plugin
export var footer = "a";
export var footerBottom = "l";
export var footerTop = "b";
export var footerTopQrcode = "c";
export var footerTopQrcodeBox = "d";
export var footerTopQrcodeBoxImg = "e";
export var footerTopQrcodeText = "f";
export var footerTopQrcodeTextHighlight = "g";
export var footerTopRight = "h";
export var footerTopRightAddress = "k";
export var footerTopRightDescription = "j";
export var footerTopRightLogo = "i";